module.exports = __webpack_public_path__ + "img/xm09-42a4a5.png";